import { render, staticRenderFns } from "./resgister.vue?vue&type=template&id=54a247eb&scoped=true&"
import script from "./resgister.vue?vue&type=script&lang=js&"
export * from "./resgister.vue?vue&type=script&lang=js&"
import style0 from "./resgister.vue?vue&type=style&index=0&id=54a247eb&lang=scss&scoped=true&"
import style1 from "./resgister.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./resgister.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a247eb",
  null
  
)

export default component.exports